/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorType } from '@ckeditor/ckeditor5-metadata';

import { plugins } from '../../constants/plugins';
import type { EditorPlugins } from '../../types/EditorPlugins';

export function findDisabledPlugins( editorPlugins: EditorPlugins, editorType: EditorType ): EditorPlugins {
	return editorPlugins.filter( editorPlugin => {
		const pluginData = plugins.find( plugin => plugin.className === editorPlugin )!;

		return pluginData.unsupportedEditorTypes.includes( editorType );
	} );
}
